jQuery( document ).ready(function($) {
    $('.box-text').matchHeight({byRow: true, property: 'height', target: null, remove: false});
    $('.match-height').matchHeight({byRow: true, property: 'height', target: null, remove: false});
    $('.blog-header').matchHeight({byRow: true, property: 'height', target: null, remove: false});

    gsap.registerPlugin(ScrollTrigger);

    gsap.utils.toArray(".fadein").forEach(fadein => {
        gsap.set(fadein, {
            opacity: 0 
        });
        var tl = gsap.timeline({
            scrollTrigger: {
                trigger: fadein,
                start: "top 70%",
                end: "bottom 20%"
            } 
        });

        tl.to(fadein, {
            duration: 1.5,
            opacity: 1
        });
    });

    const scrollElements = gsap.utils.toArray('.fadeInList');
    scrollElements.forEach(element => {
        gsap.set(element, {
            opacity: 0,
            x: -10
        });

        element.anim = gsap.to(element, {
            duration: 0.5,
            paused: true,
            opacity: 1,
            x: 0
        });
    });

    function staggerPlayBatch(batch) {
        gsap.to(batch, { stagger: {
            each: 0.5,
            onStart: function() { this.targets()[0].anim.play() }
        }})
    }

    ScrollTrigger.batch(scrollElements, {
        onEnter: staggerPlayBatch
    });

   /* var myElement = document.querySelector("header");
    // construct an instance of Headroom, passing the element
    var headroom  = new Headroom(myElement);
    // initialise
    headroom.init();*/

    var date = new Date();
    var minutes;
    document.getElementById('lgc-signup-popup').style.display = 'none';
    document.cookie = "newsletterPopup=viewed; expires="+date.setTime(date.getTime() + (minutes * 60 * 1000)) + "; path=/";

    $(".lgc-subscribe").click(function(){
        setCookie('popuped', true, 10);
        document.getElementById('lgc-signup-popup').style.display = 'none';
    });

    $("#lgc-popup-close").click(function(){
        setCookie('popuped', true, 10);
        document.getElementById('lgc-signup-popup').style.display = 'none';
    });

    function setCookie(key, value, expiry) {
        var expires = new Date();
        expires.setTime(expires.getTime() + (expiry * 24 * 60 * 60 * 1000));
        document.cookie = key + '=' + value + ';expires=' + expires.toUTCString() + ";domain=."+ window.location.hostname +";path=/";;
    }

    function getCookie(key) {
        var keyValue = document.cookie.match('(^|;) ?' + key + '=([^;]*)(;|$)');
        return keyValue ? keyValue[2] : null;
    }

    if ( getCookie("popuped") === null){
        setTimeout(function(){
            console.log('popup shown');
            document.getElementById('lgc-signup-popup').style.display = 'block';
        }, 4000);
        
        setCookie('popuped', true, 10);
    }

})